<template>
  <a-drawer
    :title="title"
    :maskClosable="false"
    width=650
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
    style="overflow: auto;padding-bottom: 53px;">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.header']">
          <a-input :placeholder="language['common.pleaseInput']+language['announcement.header']" v-decorator="['esTitle', {}]" :disabled="disableSubmit" :title="model.esTitle"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.msgContent']">
          <a-input :placeholder="language['common.pleaseInput']+language['announcement.msgContent']" v-decorator="['esContent', {}]" :disabled="disableSubmit" :title="model.esContent"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.sendRequiredParameters']">
          <a-input :placeholder="language['common.pleaseInput']+language['announcement.sendRequiredParameters']" v-decorator="['esParam', {}]" :disabled="disableSubmit" :title="model.esParam"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.esReceiver']">
          <a-input :placeholder="language['common.pleaseInput']+language['announcement.esReceiver']" v-decorator="['esReceiver', {}]" :disabled="disableSubmit" :title="model.esReceiver"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.esType']">
          <j-dict-select-tag :triggerChange="true" dictCode="msgType" v-decorator="[ 'esType', {}]" :placeholder="language['common.pleaseChoose']+language['announcement.esType']" :disabled="disableSubmit">
          </j-dict-select-tag>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.esSendTime']">
          <a-date-picker showTime format='YYYY-MM-DD HH:mm:ss' v-decorator="[ 'esSendTime', {}]" :disabled="disableSubmit"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.esSendStatus']">
          <j-dict-select-tag :triggerChange="true" dictCode="msgSendStatus" v-decorator="[ 'esSendStatus', {}]" :placeholder="language['common.pleaseChoose']+language['announcement.esSendStatus']" :disabled="disableSubmit">
          </j-dict-select-tag>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.esSendNum']">
          <a-input-number v-decorator="[ 'esSendNum', {}]" :disabled="disableSubmit"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['announcement.sendErrorResult']">
          <a-input v-decorator="['esResult', {}]" :disabled="disableSubmit"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['common.remark']">
          <a-input v-decorator="['remark', {}]" :disabled="disableSubmit"/>
        </a-form-item>
      </a-form>
    </a-spin>
    <div v-show="!disableSubmit">
      <a-button style="margin-right: .8rem" @confirm="handleCancel">{{language['common.cancel']}}</a-button>
      <a-button @click="handleOk" type="primary" :loading="confirmLoading">{{language['common.submitButton']}}</a-button>
    </div>
  </a-drawer>
</template>

<script>
  import {httpAction} from '@/api/manage'
  import { get, pick } from 'lodash';
  import moment from "moment"

  export default {
    name: "SysMessageModal",
    data() {
      return {
        title: "",
        visible: false,
        model: {},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },

        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules: {},
        disableSubmit: true,
        url: {
          add: "/sys/message/sysMessage/add",
          edit: "/sys/message/sysMessage/edit",
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    created() {
    },
    methods: {
      add() {
        this.edit({});
      },
      edit(record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'esContent', 'esParam', 'esReceiver', 'esResult', 'esSendNum', 'esSendStatus', 'esTitle', 'esType', 'remark'))
          //时间格式化
          this.form.setFieldsValue({esSendTime: this.model.esSendTime ? moment(this.model.esSendTime) : null})
        });

      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //时间格式化
            formData.esSendTime = formData.esSendTime ? formData.esSendTime.format('YYYY-MM-DD HH:mm:ss') : null;

            console.log(formData)
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })


          }
        })
      },
      handleCancel() {
        this.close()
      },


    }
  }
</script>

<style scoped>

</style>